module.exports = __webpack_public_path__ + "static/media/ArrowRightBlack.e9ca4723.svg";